import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/email-history',
    name: 'EmailsHistoryPage',
    component: () => import('@/modules/emailsHistory/views/EmailsHistoryPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
